import React from "react";

const LEFT_PAGE = "LEFT";
const RIGHT_PAGE = "RIGHT";

export function Pagination({ totalRows, currentPage, pageSize, pageNeighbours = 1, onPageChange, maxPage }) {
    let totalPages = Math.ceil(totalRows / pageSize);
    if (maxPage && totalPages > maxPage) {
        totalPages = maxPage;
    }
    const pages = fetchPageNumbers(totalPages, currentPage, pageNeighbours);

    function handleClick(page, e) {
        e.preventDefault();
        onPageChange(page);
    }

    return (
        <ul className="pagination" style={{ margin: '2px 0' }}>
            {pages.map((page, index) => {
                if (page === LEFT_PAGE || page === RIGHT_PAGE) {
                    return (
                        <li
                            key={index}
                            className="disabled"
                        >
                            <a>
                                <span aria-hidden="true">...</span>
                            </a>
                        </li>
                    );
                }

                return (
                    <li
                        key={index}
                        className={currentPage === page ? "active" : undefined}
                    >
                        <a
                            href="#"
                            onClick={e => handleClick(page, e)}
                        >
                            {page}
                        </a>
                    </li>
                );
            })}
        </ul>
    );
}

function fetchPageNumbers(totalPages, currentPage, pageNeighbours) {
    const totalNumbers = pageNeighbours * 2 + 3;
    const totalBlocks = totalNumbers + 2;

    if (totalPages > totalBlocks) {
        let pages = [];

        const leftBound = currentPage - pageNeighbours;
        const rightBound = currentPage + pageNeighbours;
        const beforeLastPage = totalPages - 1;

        const startPage = leftBound > 2 ? leftBound : 2;
        const endPage = rightBound < beforeLastPage ? rightBound : beforeLastPage;

        pages = range(startPage, endPage);

        const pagesCount = pages.length;
        const singleSpillOffset = totalNumbers - pagesCount - 1;

        const leftSpill = startPage > 2;
        const rightSpill = endPage < beforeLastPage;

        const leftSpillPage = LEFT_PAGE;
        const rightSpillPage = RIGHT_PAGE;

        if (leftSpill && !rightSpill) {
            const extraPages = range(startPage - singleSpillOffset, startPage - 1);
            pages = [leftSpillPage, ...extraPages, ...pages];
        } else if (!leftSpill && rightSpill) {
            const extraPages = range(endPage + 1, endPage + singleSpillOffset);
            pages = [...pages, ...extraPages, rightSpillPage];
        } else if (leftSpill && rightSpill) {
            pages = [leftSpillPage, ...pages, rightSpillPage];
        }

        return [1, ...pages, totalPages];
    }

    return range(1, totalPages);
}

function range(from, to, step = 1) {
    let i = from;
    const range = [];

    while (i <= to) {
        range.push(i);
        i += step;
    }

    return range;
}